var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("collectionCenter.generate") + "MDFE",
            visible: _vm.showAddMDFEWindow,
            width: "80%",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "modal-append-to-body": true,
            top: "5%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showAddMDFEWindow = $event
            },
            close: _vm.closeWindow,
          },
        },
        [
          _c("div", [
            _vm.step === 1
              ? _c(
                  "div",
                  [
                    _c(
                      "el-tabs",
                      {
                        attrs: { type: "border-card" },
                        model: {
                          value: _vm.activeName,
                          callback: function ($$v) {
                            _vm.activeName = $$v
                          },
                          expression: "activeName",
                        },
                      },
                      [
                        _c(
                          "el-tab-pane",
                          {
                            attrs: {
                              label: _vm.$t("mdfeTranslate.ChooseVTag"),
                              name: "tag",
                            },
                          },
                          [
                            _c("div", { staticStyle: { display: "flex" } }, [
                              _c("div", { staticStyle: { width: "300px" } }, [
                                _c(
                                  "div",
                                  { staticStyle: { "margin-bottom": "5px" } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("mdfeTranslate.Queue")) +
                                        "："
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticStyle: { "margin-bottom": "5px" } },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          size: "small",
                                          type: "primary",
                                        },
                                        on: { click: _vm.addTag },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "mdfeTranslate.AddVTagToTheQueue"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          size: "small",
                                          type: "danger",
                                        },
                                        on: { click: _vm.deleteAllTag },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("mdfeTranslate.DeleteAll")
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticStyle: { flex: "1" } }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: { margin: "0 10px 5px 10px" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("mdfeTranslate.SelectedVTags")
                                      ) + " "
                                    ),
                                    _c(
                                      "span",
                                      { staticStyle: { float: "right" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "mdfeTranslate.TotalNumberOfPackages"
                                            )
                                          ) +
                                            "：" +
                                            _vm._s(_vm.selectedTagForm.vtagNum)
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      padding: "10px",
                                      border: "1px solid #ddd",
                                      "border-radius": "3px",
                                      margin: "0 10px",
                                      "min-height": "200px",
                                      "max-height": "400px",
                                      "overflow-y": "auto",
                                    },
                                  },
                                  _vm._l(
                                    _vm.selectedTagForm.vtag,
                                    function (item, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: item.vtag,
                                          staticStyle: {
                                            padding: "5px 10px",
                                            border: "1px solid #ddd",
                                            "border-radius": "3px",
                                            "margin-bottom": "10px",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.checkVtagDetail(item)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "align-items": "center",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticStyle: { flex: "1" } },
                                                [_vm._v(_vm._s(item.vtag))]
                                              ),
                                              _c(
                                                "div",
                                                [
                                                  _c("el-button", {
                                                    attrs: {
                                                      size: "small",
                                                      type: "danger",
                                                      icon: "el-icon-delete",
                                                      circle: "",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.delTag(index)
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.step === 2
              ? _c(
                  "div",
                  [
                    _c(
                      "el-form",
                      {
                        ref: "step2",
                        attrs: {
                          model: _vm.selectedTagForm,
                          "label-position": "top",
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("mdfeTranslate.ChooseCompany"),
                              prop: "companyId",
                              rules: {
                                required: true,
                                message: _vm.$t("placeOrder.pleaseChoose"),
                                trigger: ["blur", "change"],
                              },
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "formTable",
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "placeOrder.pleaseChoose"
                                  ),
                                  clearable: "",
                                  filterable: "",
                                  remote: "",
                                  "reserve-keyword": "",
                                  "remote-method": _vm.getCompanyList,
                                },
                                on: { "visible-change": _vm.handleCompanyList },
                                model: {
                                  value: _vm.selectedTagForm.companyId,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.selectedTagForm,
                                      "companyId",
                                      $$v
                                    )
                                  },
                                  expression: "selectedTagForm.companyId",
                                },
                              },
                              _vm._l(_vm.companyList, function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: {
                                    label: item.fantasyName
                                      ? item.fantasyName
                                      : item.name,
                                    value: item.id,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-weight": "bold",
                              "margin-bottom": "10px",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("mdfeTranslate.RouteInformation"))
                            ),
                          ]
                        ),
                        _c(
                          "el-row",
                          { attrs: { gutter: 10 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      padding: "10px",
                                      background: "#00A551",
                                      "border-radius": "3px",
                                      color: "#fff",
                                      "align-items": "center",
                                      "margin-bottom": "10px",
                                    },
                                  },
                                  [
                                    _c("div", { staticStyle: { flex: "1" } }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("mdfeTranslate.source"))
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          flex: "1",
                                          "text-align": "center",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("mdfeTranslate.quantity")
                                          ) +
                                            "：" +
                                            _vm._s(
                                              _vm.selectedTagForm.startUF.length
                                            )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          flex: "1",
                                          "text-align": "right",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticStyle: { padding: "3px" },
                                            attrs: {
                                              type: "text",
                                              size: "mini",
                                            },
                                            on: { click: _vm.addStartUF },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-circle-plus-outline",
                                              staticStyle: {
                                                color: "#fff",
                                                "font-size": "20px",
                                              },
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._l(
                                  _vm.selectedTagForm.startUF,
                                  function (item, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticStyle: {
                                          padding: "10px",
                                          border: "1px solid #eee",
                                          "border-radius": "3px",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "font-weight": "bold",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(index + 1) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "mdfeTranslate.source"
                                                      )
                                                    )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "el-button",
                                              {
                                                staticStyle: { float: "right" },
                                                attrs: {
                                                  disabled:
                                                    _vm.selectedTagForm.startUF
                                                      .length === 1,
                                                  type: "text",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.deletestartUF(
                                                      index
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-delete",
                                                  staticStyle: {
                                                    "font-size": "20px",
                                                    color: "#f56c6c",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "collectionCenter.zipCode"
                                              ),
                                              prop: "startUF." + index + ".cep",
                                              rules: {
                                                required: true,
                                                validator: _vm.checkPostcode,
                                                type: 1,
                                                index: index,
                                                trigger: ["change"],
                                              },
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                placeholder: _vm.$t(
                                                  "placeOrder.pleaseInput"
                                                ),
                                                clearable: "",
                                                maxlength: 8,
                                                "show-word-limit": "",
                                              },
                                              model: {
                                                value: item.cep,
                                                callback: function ($$v) {
                                                  _vm.$set(item, "cep", $$v)
                                                },
                                                expression: "item.cep",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              padding: "10px",
                                              border: "1px solid #eee",
                                              "border-radius": "3px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " UF：" + _vm._s(item.uf) + " "
                                            ),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "mdfeTranslate.cityCode"
                                                  )
                                                ) +
                                                  "：" +
                                                  _vm._s(item.cityCode)
                                              ),
                                            ]),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "mdfeTranslate.CityName"
                                                  )
                                                ) +
                                                  "：" +
                                                  _vm._s(item.cityName)
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      padding: "10px",
                                      background: "#00A551",
                                      "border-radius": "3px",
                                      color: "#fff",
                                      "align-items": "center",
                                      "margin-bottom": "10px",
                                    },
                                  },
                                  [
                                    _c("div", { staticStyle: { flex: "1" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("mdfeTranslate.RoutePoint")
                                        )
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          flex: "1",
                                          "text-align": "center",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("mdfeTranslate.quantity")
                                          ) +
                                            "：" +
                                            _vm._s(
                                              _vm.selectedTagForm.throughUF
                                                .length
                                            )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          flex: "1",
                                          "text-align": "right",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticStyle: { padding: "3px" },
                                            attrs: {
                                              type: "text",
                                              size: "mini",
                                            },
                                            on: { click: _vm.addthroughUF },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-circle-plus-outline",
                                              staticStyle: {
                                                color: "#fff",
                                                "font-size": "20px",
                                              },
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._l(
                                  _vm.selectedTagForm.throughUF,
                                  function (item, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticStyle: {
                                          padding: "10px",
                                          border: "1px solid #eee",
                                          "border-radius": "3px",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "font-weight": "bold",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(index + 1) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "mdfeTranslate.way"
                                                      )
                                                    )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "el-button",
                                              {
                                                staticStyle: { float: "right" },
                                                attrs: { type: "text" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.deletethroughUF(
                                                      index
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-delete",
                                                  staticStyle: {
                                                    "font-size": "20px",
                                                    color: "#f56c6c",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label:
                                                _vm.$t("mdfeTranslate.way"),
                                              prop:
                                                "throughUF." + index + ".uf",
                                              rules: {
                                                required: true,
                                                message: _vm.$t(
                                                  "placeOrder.pleaseInput"
                                                ),
                                                trigger: ["blur", "change"],
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  placeholder: _vm.$t(
                                                    "placeOrder.pleaseChoose"
                                                  ),
                                                  clearable: "",
                                                  filterable: "",
                                                },
                                                model: {
                                                  value: item.uf,
                                                  callback: function ($$v) {
                                                    _vm.$set(item, "uf", $$v)
                                                  },
                                                  expression: "item.uf",
                                                },
                                              },
                                              _vm._l(
                                                _vm.senderStateList,
                                                function (list) {
                                                  return _c("el-option", {
                                                    key: list.stateCode,
                                                    attrs: {
                                                      label:
                                                        list.stateNameZh +
                                                        "（" +
                                                        list.stateNamePu +
                                                        "）",
                                                      value: list.stateCode,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      padding: "10px",
                                      background: "#00A551",
                                      "border-radius": "3px",
                                      color: "#fff",
                                      "align-items": "center",
                                      "margin-bottom": "10px",
                                    },
                                  },
                                  [
                                    _c("div", { staticStyle: { flex: "1" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("mdfeTranslate.destination")
                                        )
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          flex: "1",
                                          "text-align": "center",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("mdfeTranslate.quantity")
                                          ) +
                                            "：" +
                                            _vm._s(
                                              _vm.selectedTagForm.endUF.length
                                            )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          flex: "1",
                                          "text-align": "right",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticStyle: { padding: "3px" },
                                            attrs: {
                                              type: "text",
                                              size: "mini",
                                            },
                                            on: { click: _vm.addendUF },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-circle-plus-outline",
                                              staticStyle: {
                                                color: "#fff",
                                                "font-size": "20px",
                                              },
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._l(
                                  _vm.selectedTagForm.endUF,
                                  function (item, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticStyle: {
                                          padding: "10px",
                                          border: "1px solid #eee",
                                          "border-radius": "3px",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "font-weight": "bold",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(index + 1) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "mdfeTranslate.destination"
                                                      )
                                                    )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "el-button",
                                              {
                                                staticStyle: { float: "right" },
                                                attrs: {
                                                  disabled:
                                                    _vm.selectedTagForm.endUF
                                                      .length === 1,
                                                  type: "text",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.deleteendUF(
                                                      index
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-delete",
                                                  staticStyle: {
                                                    "font-size": "20px",
                                                    color: "#f56c6c",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "collectionCenter.zipCode"
                                              ),
                                              prop: "endUF." + index + ".cep",
                                              rules: {
                                                required: true,
                                                validator: _vm.checkPostcode,
                                                type: 2,
                                                index: index,
                                                trigger: ["change"],
                                              },
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                placeholder: _vm.$t(
                                                  "placeOrder.pleaseInput"
                                                ),
                                                clearable: "",
                                                maxlength: 8,
                                                "show-word-limit": "",
                                              },
                                              model: {
                                                value: item.cep,
                                                callback: function ($$v) {
                                                  _vm.$set(item, "cep", $$v)
                                                },
                                                expression: "item.cep",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              padding: "10px",
                                              border: "1px solid #eee",
                                              "border-radius": "3px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " UF：" + _vm._s(item.uf) + " "
                                            ),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "mdfeTranslate.cityCode"
                                                  )
                                                ) +
                                                  "：" +
                                                  _vm._s(item.cityCode)
                                              ),
                                            ]),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "mdfeTranslate.CityName"
                                                  )
                                                ) +
                                                  "：" +
                                                  _vm._s(item.cityName)
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.step === 3
              ? _c(
                  "div",
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "font-weight": "bold",
                          "margin-bottom": "10px",
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("mdfeTranslate.DriverAndVehicle")))]
                    ),
                    _c(
                      "el-form",
                      {
                        ref: "step3",
                        attrs: {
                          model: _vm.selectedTagForm,
                          "label-position": "top",
                        },
                      },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 10 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("collectionCenter.driver1"),
                                      prop: "selectedDriver",
                                      rules: {
                                        required: true,
                                        message: _vm.$t(
                                          "GlobalSetObj.pleaseChoose"
                                        ),
                                        trigger: ["blur", "change"],
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "formTable",
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "placeOrder.pleaseChoose"
                                          ),
                                          clearable: "",
                                          filterable: "",
                                          remote: "",
                                          "reserve-keyword": "",
                                          "remote-method": _vm.getDriverInfo,
                                        },
                                        on: {
                                          "visible-change":
                                            _vm.handleDriverInfo,
                                          change: _vm.handleDriverChange,
                                        },
                                        model: {
                                          value:
                                            _vm.selectedTagForm.selectedDriver,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.selectedTagForm,
                                              "selectedDriver",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "selectedTagForm.selectedDriver",
                                        },
                                      },
                                      _vm._l(_vm.driverList, function (item) {
                                        return _c("el-option", {
                                          key: item.id,
                                          attrs: {
                                            label: item.driverName,
                                            value: item.id,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "collectionCenter.licensePlateNumber"
                                      ),
                                      prop: "vehiclePlate",
                                      rules: {
                                        required:
                                          _vm.selectedTagForm.selectedDriverItem
                                            .length === 0,
                                        message: _vm.$t(
                                          "collectionCenter.notNull"
                                        ),
                                        trigger: ["change"],
                                      },
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "placeOrder.pleaseInput"
                                        ),
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.selectedTagForm.vehiclePlate,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.selectedTagForm,
                                            "vehiclePlate",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "selectedTagForm.vehiclePlate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c(
                        "div",
                        { staticStyle: { flex: "1", "padding-right": "5px" } },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.addDriver },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "mdfeTranslate.ChooseVehicleAndDriver"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticStyle: { flex: "1", "padding-left": "5px" } },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { size: "small", type: "danger" },
                              on: { click: _vm.deleteAllDriver },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("mdfeTranslate.DeleteAll")) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticStyle: { "margin-top": "10px" } }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-weight": "bold",
                            "margin-bottom": "10px",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("mdfeTranslate.SelectedDriver")))]
                      ),
                    ]),
                    _vm.selectedTagForm.selectedDriverItem.length > 0
                      ? _c(
                          "div",
                          {
                            key: _vm.selectedTagFormKey,
                            staticStyle: { display: "flex" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  flex: "1",
                                  padding: "10px",
                                  border: "1px solid #ccc",
                                  "border-radius": "5px",
                                  "margin-right": "10px",
                                  height: "500px",
                                  "overflow-y": "auto",
                                },
                              },
                              _vm._l(
                                _vm.selectedTagForm.selectedDriverItem,
                                function (item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticStyle: { "margin-bottom": "10px" },
                                    },
                                    [
                                      index === 0
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                color: "black",
                                                "font-weight": "bold",
                                                height: "50px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " + _vm._s(item.name) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            border: "1px solid #ccc",
                                            "border-radius": "5px",
                                            padding: "6px",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticStyle: { flex: "1" } },
                                            [
                                              _c("div", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "collectionCenter.compellation"
                                                    )
                                                  ) +
                                                    ": " +
                                                    _vm._s(item.name)
                                                ),
                                              ]),
                                              _c("div", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "mdfeTranslate.document"
                                                    )
                                                  ) +
                                                    "(CPF/CNPJ): " +
                                                    _vm._s(item.cpf)
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticStyle: { width: "50px" } },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "danger",
                                                    size: "mini",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.deleteDriver(
                                                        index
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-delete",
                                                  }),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  flex: "1",
                                  padding: "10px",
                                  border: "1px solid #ccc",
                                  "border-radius": "5px",
                                  "margin-left": "10px",
                                },
                              },
                              [
                                _c("div", [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        color: "black",
                                        "font-weight": "bold",
                                        height: "50px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.vehicleInformation
                                            .licensePlateNumber
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "GlobalSetObj.licensePlateNumber"
                                        )
                                      ) +
                                        ": " +
                                        _vm._s(
                                          _vm.vehicleInformation
                                            .licensePlateNumber
                                        )
                                    ),
                                  ]),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("mdfeTranslate.TrailerRENAVAM")
                                      ) +
                                        ": " +
                                        _vm._s(
                                          _vm.vehicleInformation.TrailerRENAVAM
                                        )
                                    ),
                                  ]),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("mdfeTranslate.TrailerTare")
                                      ) +
                                        ": " +
                                        _vm._s(
                                          _vm.vehicleInformation.TrailerTare
                                        )
                                    ),
                                  ]),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("mdfeTranslate.TrailerCapacity")
                                      ) +
                                        ": " +
                                        _vm._s(
                                          _vm.vehicleInformation.TrailerCapacity
                                        )
                                    ),
                                  ]),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("mdfeTranslate.TrailerRNTRC")
                                      ) +
                                        ": " +
                                        _vm._s(
                                          _vm.vehicleInformation.TrailerRNTRC
                                        )
                                    ),
                                  ]),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("mdfeTranslate.TruckDocuments")
                                      ) +
                                        ": " +
                                        _vm._s(
                                          _vm.vehicleInformation
                                            .TrailerDocuments
                                        )
                                    ),
                                  ]),
                                  _c("div", [
                                    _vm._v(
                                      "IE: " + _vm._s(_vm.vehicleInformation.ie)
                                    ),
                                  ]),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(_vm.$t("mdfeTranslate.State")) +
                                        ": " +
                                        _vm._s(_vm.vehicleInformation.State)
                                    ),
                                  ]),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("mdfeTranslate.WheelKind")
                                      ) +
                                        ": " +
                                        _vm._s(_vm.vehicleInformation.WheelKind)
                                    ),
                                  ]),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("mdfeTranslate.VehicleType")
                                      ) +
                                        ": " +
                                        _vm._s(
                                          _vm.vehicleInformation.vehicleType
                                        )
                                    ),
                                  ]),
                                ]),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm.step === 4
              ? _c(
                  "div",
                  [
                    _c(
                      "el-form",
                      {
                        ref: "step4",
                        attrs: {
                          model: _vm.selectedTagForm,
                          "label-position": "top",
                        },
                      },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 10 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "appendTag",
                                    attrs: {
                                      label: _vm.$t(
                                        "mdfeTranslate.TrailerPlateNumber"
                                      ),
                                      prop: "veicReboque",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-input",
                                      {
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "placeOrder.pleaseInput"
                                          ),
                                        },
                                        nativeOn: {
                                          keydown: function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            return _vm.addVeicReboque($event)
                                          },
                                        },
                                        model: {
                                          value:
                                            _vm.selectedTagForm.veicReboque,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.selectedTagForm,
                                              "veicReboque",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "selectedTagForm.veicReboque",
                                        },
                                      },
                                      [
                                        _c("template", { slot: "append" }, [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-circle-plus-outline",
                                            staticStyle: {
                                              "font-size": "26px",
                                            },
                                            on: { click: _vm.addVeicReboque },
                                          }),
                                        ]),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("div", { staticStyle: { "margin-top": "10px" } }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-weight": "bold",
                            "margin-bottom": "10px",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("mdfeTranslate.SelectedVehicles"))
                          ),
                        ]
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "driver-container" },
                      _vm._l(_vm.veicReboqueList, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "driver-item",
                            class: _vm.getColSpan(
                              index,
                              _vm.veicReboqueList.length
                            ),
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  color: "black",
                                  "font-weight": "bold",
                                  height: "50px",
                                },
                              },
                              [
                                _vm._v(_vm._s(item.licensePlateNumber) + " "),
                                _c(
                                  "div",
                                  { staticStyle: { float: "right" } },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "danger",
                                          size: "small",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteVeicReboque(index)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-delete",
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _c("div", [
                              _c("div", [
                                _vm._v(
                                  _vm._s(_vm.$t("mdfeTranslate.Proprietário")) +
                                    ": " +
                                    _vm._s(item.providerName)
                                ),
                              ]),
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("GlobalSetObj.licensePlateNumber")
                                  ) +
                                    ": " +
                                    _vm._s(item.licensePlateNumber)
                                ),
                              ]),
                              _c("div", [
                                _vm._v(
                                  _vm._s(_vm.$t("mdfeTranslate.document")) +
                                    "(CPF/CNPJ): " +
                                    _vm._s(item.driverDocument)
                                ),
                              ]),
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("mdfeTranslate.TrailerRENAVAM")
                                  ) +
                                    ": " +
                                    _vm._s(item.TrailerRENAVAM)
                                ),
                              ]),
                              _c("div", [
                                _vm._v(
                                  _vm._s(_vm.$t("mdfeTranslate.TrailerTare")) +
                                    ": " +
                                    _vm._s(item.TrailerTare)
                                ),
                              ]),
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("mdfeTranslate.TrailerCapacity")
                                  ) +
                                    ": " +
                                    _vm._s(item.TrailerCapacity)
                                ),
                              ]),
                              _c("div", [
                                _vm._v(
                                  _vm._s(_vm.$t("mdfeTranslate.TrailerRNTRC")) +
                                    ": " +
                                    _vm._s(item.TrailerRNTRC)
                                ),
                              ]),
                              _c("div", [_vm._v("IE: " + _vm._s(item.ie))]),
                              _c("div", [
                                _vm._v(
                                  _vm._s(_vm.$t("mdfeTranslate.State")) +
                                    ": " +
                                    _vm._s(item.State)
                                ),
                              ]),
                              _c("div", [
                                _vm._v(
                                  _vm._s(_vm.$t("mdfeTranslate.VehicleType")) +
                                    ": " +
                                    _vm._s(item.vehicleType)
                                ),
                              ]),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c(
            "div",
            { staticStyle: { "margin-top": "10px", "text-align": "right" } },
            [
              _vm.step !== 1
                ? _c(
                    "el-button",
                    {
                      staticStyle: { float: "left" },
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.previousStep },
                    },
                    [_vm._v(_vm._s(_vm.$t("mdfeTranslate.Previous")))]
                  )
                : _vm._e(),
              _vm.step !== 4
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.nextStep },
                    },
                    [_vm._v(_vm._s(_vm.$t("mdfeTranslate.Next")))]
                  )
                : _vm._e(),
              _vm.step === 4
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.createOrder },
                    },
                    [_vm._v(_vm._s(_vm.$t("collectionCenter.submit")))]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("mdfeTranslate.VTagsQueue"),
            visible: _vm.showAddTagWindow,
            width: "60%",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "modal-append-to-body": true,
            top: "5%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showAddTagWindow = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                { attrs: { model: _vm.selectTag, "label-position": "top" } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("mdfeTranslate.SelectTheVTagType"),
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: {
                            disabled: _vm.selectedTagForm.vtag.length > 0,
                          },
                          model: {
                            value: _vm.selectTag.vtagType,
                            callback: function ($$v) {
                              _vm.$set(_vm.selectTag, "vtagType", $$v)
                            },
                            expression: "selectTag.vtagType",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "COLLECT" } }, [
                            _vm._v(_vm._s(_vm.$t("mdfeTranslate.Coleta"))),
                          ]),
                          _c("el-radio", { attrs: { label: "DELIVERY" } }, [
                            _vm._v(_vm._s(_vm.$t("mdfeTranslate.Entrega"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "appendTag",
                      attrs: { label: _vm.$t("mdfeTranslate.ListOfVTags") },
                    },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: {
                            placeholder: _vm.$t("placeOrder.pleaseInput"),
                          },
                          nativeOn: {
                            keydown: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              return _vm.appendTag($event)
                            },
                          },
                          model: {
                            value: _vm.tag,
                            callback: function ($$v) {
                              _vm.tag =
                                typeof $$v === "string" ? $$v.trim() : $$v
                            },
                            expression: "tag",
                          },
                        },
                        [
                          _c("template", { slot: "append" }, [
                            _c("i", {
                              staticClass: "el-icon-circle-plus-outline",
                              staticStyle: { "font-size": "26px" },
                              on: { click: _vm.appendTag },
                            }),
                          ]),
                        ],
                        2
                      ),
                      _c("div", { staticStyle: { "margin-top": "10px" } }, [
                        _c("div", [
                          _vm._v(_vm._s(_vm.$t("mdfeTranslate.SelectedVTag"))),
                        ]),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              border: "1px solid #ddd",
                              "border-radius": "3px",
                              height: "300px",
                              padding: "10px",
                              "overflow-y": "auto",
                            },
                          },
                          _vm._l(_vm.selectTag.vtag, function (item, index) {
                            return _c(
                              "div",
                              {
                                key: item.vtag,
                                staticStyle: {
                                  padding: "5px 10px",
                                  border: "1px solid #ddd",
                                  "border-radius": "3px",
                                  "margin-bottom": "10px",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                    },
                                  },
                                  [
                                    _c("div", { staticStyle: { flex: "1" } }, [
                                      _vm._v(_vm._s(item.vtag)),
                                    ]),
                                    _c(
                                      "div",
                                      [
                                        _c("el-button", {
                                          attrs: {
                                            size: "small",
                                            type: "danger",
                                            icon: "el-icon-delete",
                                            circle: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.removeTag(index)
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    disabled: _vm.selectTag.vtag.length === 0,
                  },
                  on: { click: _vm.confirmAppend },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.showAddTagWindow = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.cancel")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.vtagDetail.vtag,
            visible: _vm.showVtagDetail,
            width: "60%",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "modal-append-to-body": true,
            top: "5%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showVtagDetail = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                border: "1px solid #ddd",
                "border-radius": "5px",
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    flex: "1",
                    padding: "10px",
                    display: "flex",
                    "flex-direction": "column",
                    "justify-content": "center",
                  },
                },
                [
                  _c("div", [
                    _vm._v(
                      _vm._s(_vm.$t("mdfeTranslate.QuantityOfPackages")) +
                        "：" +
                        _vm._s(_vm.vtagDetail.validPackage.length)
                    ),
                  ]),
                  _c("div", [
                    _vm._v(_vm._s(_vm.$t("mdfeTranslate.FreteTotal")) + "： "),
                    _vm.$i18n.locale !== "zh"
                      ? _c("span", [
                          _vm._v(
                            "R$ " +
                              _vm._s(_vm.formatNumber(_vm.vtagDetail.totalCost))
                          ),
                        ])
                      : _c("span", [
                          _vm._v(_vm._s(_vm.vtagDetail.totalCost) + " 雷亚尔"),
                        ]),
                  ]),
                  _c("div", [
                    _vm._v(_vm._s(_vm.$t("mdfeTranslate.TotalValue")) + "： "),
                    _vm.$i18n.locale !== "zh"
                      ? _c("span", [
                          _vm._v(
                            "R$ " +
                              _vm._s(
                                _vm.formatNumber(_vm.vtagDetail.totalPrice)
                              )
                          ),
                        ])
                      : _c("span", [
                          _vm._v(_vm._s(_vm.vtagDetail.totalPrice) + " 雷亚尔"),
                        ]),
                  ]),
                  _c("div", [
                    _vm._v(
                      _vm._s(_vm.$t("mdfeTranslate.TotalWeight")) +
                        "：" +
                        _vm._s(_vm.vtagDetail.totalWeight) +
                        " KG"
                    ),
                  ]),
                ]
              ),
              _c("div", { staticStyle: { flex: "1", padding: "10px" } }, [
                _c("div", [_vm._v(_vm._s(_vm.$t("mdfeTranslate.Packages")))]),
                _c(
                  "div",
                  {
                    staticStyle: {
                      border: "1px solid #ddd",
                      "border-radius": "5px",
                      padding: "10px",
                      height: "500px",
                      "overflow-y": "auto",
                    },
                  },
                  _vm._l(_vm.vtagDetail.validPackage, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticStyle: {
                          padding: "3px 5px",
                          background: "#ededed",
                          "border-radius": "3px",
                          margin: "5px 0",
                        },
                      },
                      [_vm._v(_vm._s(item))]
                    )
                  }),
                  0
                ),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.showVtagDetail = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.close")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }